import React from 'react'

function Textures() {
    return (
        <pattern
            id="lines"
            patternUnits="userSpaceOnUse"
            width="60"
            height="60"
        >
            <path
                d="M 0,60 l 60,-60 M -15,15 l 30,-30 M 45,75 l 30,-30"
                strokeWidth="40"
                shapeRendering="auto"
                stroke="#f5f5f5"
                fill="#000000"
                strokeLinecap="square"
            />
        </pattern>
    )
}

export default Textures
